export default "/app/global-wrapper-client/static/b058294352e0f3f0b9c9328e662329a9.woff";